/// <amd-module name="Search/Code/Flux/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub";
import { CodeQueryResponse, SearchQuery, CodeResult } from "Search/LegacyWebApi/Contracts/Code";

export interface IActiveTabChangedPayload {
    activeTabKey: string;
}

export class ActionsHub extends BaseActionsHub.ActionsHub<SearchQuery, CodeQueryResponse, CodeResult> {
    public activeTabChanged = new Action<IActiveTabChangedPayload>();
    public fullScreenToggled = new Action<boolean>();
}
